import React from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { Button, Input } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { errorInput } from '../../../../components/helpers';
import {
  isCaptchaRequired,
  useRecaptchaToken,
  RECAPTCHA_SECURITY_ERROR,
} from '../../../../components/helpers/recaptchaUtils';
import useRememberCredentials from '../../../../components/helpers/useRememberCredentials';
import RememberCredentialsCheckbox from '../../../../components/helpers/RememberCredentialsCheckbox';
import styled from '@emotion/styled';
import { marryInComunidadRequirements } from './StepChecks';
import { RegistrationForm } from 'src/assets/styles/components/Registration';
import Swal from 'sweetalert2';

const FormContainer = styled('div')`
  max-width: 500px;
  margin: 0 auto;
  padding: 1rem;
  margin-top: 1rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  h2 {
    font-size: 2.2rem;
    color: #2c3e50;
    margin: 0;
    text-align: center;
  }

  .welcome-label {
    display: block;
    padding: 0 0 1rem 0;
    font-size: 1.5rem;
    color: #2c3e50;
    text-align: center;
  }

  .error-message {
    color: #dc3545;
    font-size: 0.875rem;
    margin: 0.5rem 0;
    text-align: center;
  }

  .requirements-container {
    margin: 1.5rem 1.5rem 0 3rem;
  }

  .input-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;

    .ui.input {
      width: 100%;

      input {
        padding: 0.8rem;
        font-size: 1rem;
        border-radius: 8px;
        border: 2px solid #e0e0e0;
        transition: all 0.2s ease;

        &:focus {
          border-color: #3498db;
          box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
        }

        &.error {
          border-color: #dc3545;
          background-color: #fff8f8;
        }
      }
    }
  }

  .ui.button {
    width: 100%;
    padding: 1rem;
    font-size: 1.1rem;
    background: #3498db;
    color: white;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
      background: #2980b9;
      transform: translateY(-1px);
    }

    &:disabled {
      background: #bdc3c7;
      cursor: not-allowed;
    }
  }

  @media screen and (max-width: 600px) {
    padding: 1rem;
    margin: 0 1rem;

    h2 {
      font-size: 1.8rem;
    }

    .welcome-label {
      font-size: 1.3rem;
    }
  }
`;

const WeddingStepLogIn = (props) => {
  const { inputs, setInputs, getInfo, parsedQueryString, set_loading, loading, handleInputs } =
    props;
  const [errorInputs, set_errorInputs] = React.useState({});
  const getCaptchaToken = useRecaptchaToken('wedding_login');
  const { rememberCredentials, setRememberCredentials, persistCredentials } =
    useRememberCredentials({ setInputs });

  const verifyForm = () => {
    let mandatoryInputs = ['identification', 'phone'];
    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    if (inputs['identification'] && inputs['identification'].length <= 5) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'identification',
          value: inputs['identification'].length >= 5,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  React.useEffect(() => {
    if (
      parsedQueryString?.identification &&
      parsedQueryString?.phone &&
      inputs.identification &&
      inputs.phone
    ) {
      enterReservation({ preventDefault: () => {} });
    }
  }, [inputs.identification, inputs.phone]);

  const enterReservation = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    set_loading(true);

    const captchaRequired = isCaptchaRequired();
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_loading(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    persistCredentials({
      identification: inputs.identification,
      phone: inputs.phone,
    });

    getInfo({
      ...inputs,
      ...(captchaRequired ? { captcha } : {}),
    });
  };

  const onInputChange = (event) => {
    handleInputs(event);
    const { name } = event.target;
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  return (
    <FormContainer>
      <h2>¡Bienvenido!</h2>
      <div className="requirements-container">{marryInComunidadRequirements()}</div>
      <RegistrationForm onSubmit={(e) => enterReservation(e)}>
        <label className="welcome-label">Escribe tus datos para continuar</label>
        {Object.values(errorInputs).includes(true) && (
          <div className="error-message">Por favor verifica los campos en rojo.</div>
        )}
        <div className="input-container">
          <Input
            onChange={onInputChange}
            name={'identification'}
            value={inputs.identification}
            type="number"
            placeholder="Identificación"
            id="identification"
            className={`Registration__input Registration__input-${'identification'} ${
              errorInputs['identification'] ? 'error' : ''
            }`}
          />
          <Input
            placeholder="Celular"
            id="phone"
            name={'phone'}
            type="number"
            className={`Registration__input Registration__input-${'phone'} ${
              errorInputs['phone'] ? 'error' : ''
            }`}
            value={inputs.phone}
            onChange={onInputChange}
          />
        </div>
        <RememberCredentialsCheckbox
          checked={rememberCredentials}
          onChange={setRememberCredentials}
        />
        <Button primary disabled={loading} type="submit">
          Entrar
        </Button>
      </RegistrationForm>
    </FormContainer>
  );
};

export default withRouter(WeddingStepLogIn);
